var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 167,
    viewBox: "0 0 226 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Visa_svg__filter0_d_353_4566)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.323,
    y: 21.323,
    width: 182.562,
    height: 124.354,
    rx: 14.552,
    fill: "#fff",
    stroke: "#D9D9D9",
    strokeWidth: 2.646
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.225 106.033h-11.22l-8.413-32.098c-.4-1.477-1.248-2.782-2.495-3.397-3.113-1.546-6.543-2.777-10.285-3.397v-1.236h18.075a4.71 4.71 0 014.677 4.012l4.366 23.154 11.214-27.166h10.909l-16.828 40.128zm23.064 0H88.693l8.725-40.128h10.597l-8.726 40.128zm22.435-29.011c.311-2.162 2.182-3.398 4.365-3.398 3.43-.31 7.167.31 10.285 1.852l1.871-8.64c-3.119-1.236-6.549-1.857-9.661-1.857-10.285 0-17.769 5.559-17.769 13.273 0 5.869 5.301 8.95 9.043 10.806 4.048 1.851 5.608 3.087 5.296 4.938 0 2.777-3.119 4.013-6.231 4.013-3.742 0-7.484-.926-10.908-2.472l-1.871 8.645c3.741 1.541 7.79 2.162 11.531 2.162 11.532.305 18.699-5.249 18.699-13.583 0-10.497-14.65-11.112-14.65-15.74zm51.734 29.011l-8.413-40.128h-9.038c-1.871 0-3.741 1.236-4.365 3.087l-15.58 37.041h10.908l2.177-5.863h13.403l1.247 5.863h9.661zm-15.892-29.322l3.113 15.124h-8.725l5.612-15.124z",
    fill: "#172B85"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Visa_svg__filter0_d_353_4566",
    x: 0,
    y: 0,
    width: 225.208,
    height: 167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_353_4566"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_353_4566",
    result: "shape"
  })))));
}
export default SvgVisa;